const preview = process.env.CF_PREVIEW;
module.exports = `
... on PromoBannerInterview(limit: 10,preview: ${preview}) {
    nameEn
    imageDt {
      title
      description
      cloudinaryId
      asset{url}
    }
    imageSp {
      cloudinaryId
      title
      description
      asset{url}
    }
      button {
        ... on ButtonExternal {
          externalUrl
          text
          target
        }
        ... on ButtonInternal {
          text
          target
          url {
            seoHead {
              url
            }
          }
        }
      }
}
`;
